import React, {useState} from 'react'
import { Table,Container,Row,Card,CardHeader,CardBody,CardFooter, Button, Col,Form,FormGroup,Label,Input,FormText } from "reactstrap";
import {merchShop} from 'network/ApiAxiosMerchShop'
import ProdQRCode from './ProdQRCode';
import Header from 'components/Headers/Header';


function AddProduct() {
    const [desc, setDesc] = useState('');
    const [house, setHouse] = useState('Heaven');
    const [color, setColor] = useState('');
    const [sizes, setSizes] = useState('');
    const [picture, setPicture] = useState('');
    const [staff, setStaff] = useState(false);
    const [price, setPrice] = useState('');
    const [priceStaff, setPriceStaff] = useState('');
    const [prodIDs, setProdIDs] = useState('');
    const [customColor, setCustomColor] = useState('');


    const submitProduct = async(e)=>{
        e.preventDefault()
        const files = new FormData();
        picture && files.append("picture", picture);
        files.append("desc", desc);
        files.append("house", house);
        files.append("color", JSON.stringify(color));
        customColor && files.append("customColor", JSON.stringify(customColor));
        files.append("sizes", JSON.stringify(sizes));
        files.append("staff", staff);
        files.append("price", price);
        files.append("priceStaff", priceStaff);
        const resp = await merchShop(files)
        setProdIDs(resp.data)
    }

    const handleColorChange = (e) => {
        let target = e.target
        let name = target.name
        //here
        let value = Array.from(target.selectedOptions, option => option.value);
        setColor({
          [name]: value
        });
    }
    const handleSizeChange = (e) => {
        let target = e.target
        let name = target.name
        //here
        let value = Array.from(target.selectedOptions, option => option.value);
        setSizes({
          [name]: value
        });
    }
    
  return (
    <>
    <Header/>
    <Container>

    <Card color='secondary' className='mt--6' >
        <CardHeader >
            Create new product
        </CardHeader>
        <Form onSubmit={submitProduct}>
            <CardBody>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="exampleDescription">
                            Description
                            </Label>
                            <Input
                            id="exampleDescription"
                            name="description"
                            placeholder="Product description"
                            type="description"
                            value={desc}
                            onChange={(e)=>setDesc(e.target.value)}
                            required
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="exampleSelect">
                            House
                            </Label>
                            <Input
                            id="exampleSelect"
                            name="select"
                            type="select"
                            required
                            onChange={(e) => setHouse(e.target.value)}
                            >
                                <option value='Heaven'>
                                    Heaven
                                </option>
                                <option value='Albufeira 66'>
                                    Albufeira 66
                                </option>
                                <option value='Albufissa'>
                                    Albufissa
                                </option>
                                <option value='Tropicana'>
                                    Tropicana
                                </option>
                                <option value='Heaven Wharehouse'>
                                    Heaven's Wharehouse
                                </option>
                                <option value='Beach Club'>
                                    Beach Club
                                </option>
                                <option value='Other'>
                                    Other
                                </option>
                            </Input>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Label for="exampleSelect">
                            Color (Use Ctrl to select multiple)
                        </Label>
                        <FormGroup className='row justify-content-around align-content-around align-items-center' >
                            <Input
                            id="exampleSelect"
                            name="select"
                            type="select"
                            multiple
                            required
                            onChange={(e) => handleColorChange(e)}
                            >
                                <option value='Black'>
                                    Black
                                </option>
                                <option value='White'>
                                    White
                                </option>
                                <option value='Grey'>
                                    Grey
                                </option>
                                <option value='Blue'>
                                    Blue
                                </option>
                                <option value='Red'>
                                    Red
                                </option>
                                <option value='Green'>
                                    Green
                                </option>
                                <option value='Yellow'>
                                    Yellow
                                </option>
                                <option value='Baby Blue'>
                                    Baby Blue
                                </option>
                                <option value='Pink'>
                                    Pink
                                </option>
                                <option value='Other'>
                                    Other
                                </option>
                            </Input>
                            <Input className='w-50' value={customColor} onChange={(e)=>setCustomColor(e.target.value)}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="exampleSelect">
                            Available Sizes (Use Ctrl to select multiple)
                            </Label>
                            <Input
                            id="exampleSelect"
                            name="select"
                            multiple
                            type="select"
                            required
                            onChange={(e) => handleSizeChange(e)}
                            >
                                <option value='NA'>
                                    N.A
                                </option>
                                <option value='XS'>
                                    XS
                                </option>
                                <option value='S'>
                                    S
                                </option>
                                <option value='M'>
                                    M
                                </option>
                                <option value='L'>
                                    L
                                </option>
                                <option value='XL'>
                                    XL
                                </option>
                                <option value='XXL'>
                                    2XL
                                </option>
                                <option value='XXXL'>
                                    3XL
                                </option>
                                <option value='XXXXL'>
                                    4XL
                                </option>
                            </Input>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="exampleFile">
                            Picture
                            </Label>
                            <Input
                            id="exampleFile"
                            name="file"
                            type="file"
                            required
                            accept="image/*"
                            onChange={(e)=>setPicture(e.target.files[0])}
                            />
                            <FormText>
                            Take a picture of the product
                            </FormText>
                        </FormGroup>
                        </Col>
                        <Col md={6} className='mt-4' >
                        <FormGroup check>
                            <Input type="checkbox" id="exampleCheck" name="check" checked={staff} onChange={(e)=>setStaff(!staff)}/>
                            <Label for="exampleCheck" check>
                            Staff Only(check if is for staff)
                            </Label>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="Price">
                            Price
                            </Label>
                            <Input
                            id="Price"
                            name="number"
                            placeholder="Price"
                            type="number"
                            value={price}
                            required
                            onChange={(e)=>setPrice(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="StaffPrice">
                            Staff Price
                            </Label>
                            <Input
                            id="StaffPrice"
                            name="number"
                            placeholder="Staff Price"
                            type="number"
                            value={priceStaff}
                            required
                            onChange={(e)=>setPriceStaff(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </CardBody>
            <CardFooter className='text-center' >
                <Button className='mb-2'>
                    Submit
                </Button>
                {prodIDs && prodIDs.map((idItem,index)=>{
                    return <ProdQRCode key={idItem} id={idItem} name={desc + ' ' + house + ' ' + sizes.select[index] + ' ' + color.select.toString() + ' ' + price + '€'}/>
                })}
            </CardFooter>
        </Form>
    </Card>
    </Container>
    </>
  )
}

export default AddProduct